(() => {
  function initialize(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const controls = root.querySelector('.ms-filters');
    const buttons = [...controls.querySelectorAll('button')];
    const cards = [...root.querySelectorAll('[data-sport-group]')];
    const count = root.querySelector('.ms-count');
    buttons.forEach(button => {
      if (button.dataset.sportFilter !== 'all' && !cards.some(card => card.dataset.sportGroup === button.dataset.sportFilter)) button.hidden = true;
    });
    controls.hidden = false;
    controls.addEventListener('focusin', event => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('button[data-sport-filter]');
      if (!button || controls.scrollWidth <= controls.clientWidth) return;
      const frame = controls.getBoundingClientRect();
      const target = button.getBoundingClientRect();
      const inset = 6;
      const offset = target.left < frame.left + inset
        ? target.left - frame.left - inset
        : target.right > frame.right - inset ? target.right - frame.right + inset : 0;
      if (offset) controls.scrollLeft += offset;
    });
    controls.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('button[data-sport-filter]');
      if (!button) return;
      const group = button.dataset.sportFilter;
      buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      cards.forEach(card => { card.hidden = group !== 'all' && card.dataset.sportGroup !== group; });
      const total = cards.filter(card => !card.hidden).length;
      count.textContent = `${total} ${total === 1 ? 'producto' : 'productos'}${group === 'all' ? '' : ' · ' + button.textContent.trim()}`;
    });
  }
  document.querySelectorAll('[data-sport-catalog]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => initialize(event.target.querySelector('[data-sport-catalog]')));
})();
